import React from "react";
import { Chip, Stack, Typography } from "@mui/joy";
import { autodbScalar, getScalarFieldValue } from "../utils/autodbValues";

interface CompanyOperatingStatusProps {
  company: any;
}

export const CompanyOperatingStatus: React.FC<CompanyOperatingStatusProps> = ({
  company,
}) => {
  if (getScalarFieldValue(company?.value?.operating_status) !== "inactive") {
    return null;
  }

  const rawDate = getScalarFieldValue(company?.value?.status_date);
  const statusDate = typeof rawDate === "string" ? rawDate : undefined;
  const acquirer = autodbScalar(company?.value?.acquirer);
  const acquirerName =
    typeof acquirer === "string"
      ? acquirer
      : getScalarFieldValue((acquirer as any)?.name);

  return (
    <Stack
      direction="row"
      spacing={0.75}
      alignItems="center"
      flexWrap="wrap"
      sx={{ rowGap: 0.5 }}
    >
      <Chip size="sm" variant="soft" color="neutral">
        Inactive
      </Chip>
      {statusDate && (
        <Typography level="body-xs" color="neutral">
          Status date: {statusDate}
        </Typography>
      )}
      {acquirerName && (
        <Typography level="body-xs" color="neutral">
          Acquired by {acquirerName}
        </Typography>
      )}
    </Stack>
  );
};
